import withRouter from "hoc/withRouter";
import { Button, CircularProgress, IconButton, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import ListPage from "components/ListPage/ListPage";
import categoriesService from "services/admin/categoriesService";
import { useGetCategories } from "hooks/useGetCategories";
import { Link } from "react-router-dom";
import { FaTrash, FaTrashAlt } from "react-icons/fa";
import { FaPencil } from "react-icons/fa6";

const TicketCategoryList = () => {
    const { data: categoriesResponse, isLoading, refetch } = useGetCategories({
        type: 'TICKET',
        orgID: localStorage.getItem('orgID') || '',
    });

    console.log("Categories: ", categoriesResponse);

    const handleDelete = async (id: string) => {
        await categoriesService.delete(id);
        refetch();
    }

    function buildContent() {
        if (isLoading) {
            return <div className="text-center"><CircularProgress></CircularProgress></div>
        }
        if ((categoriesResponse?.data as any)?.length === 0) {
            return <div>Темы обращений отсутсвуют. Чтобы добавить тему обращения пожалуйста, нажмите на кнопку "Добавить" сверху</div>
        }
        if ((categoriesResponse?.data as any)?.length > 0) {
            return <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>#</TableCell>
                        <TableCell>Название</TableCell>
                        <TableCell>Описание</TableCell>
                        <TableCell>Действия</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {(categoriesResponse?.data as any)?.map((c: any, index: number) => (
                        <TableRow key={c.id}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{c.name}</TableCell>
                            <TableCell>{c.description}</TableCell>
                            <TableCell>
                                <div className="flex gap-2 items-center">
                                    <Link to={`/admin/tickets/categories/edit/${c.id}`}><FaPencil /></Link>
                                    <IconButton color="error" onClick={() => handleDelete(c.id)}><FaTrashAlt /></IconButton>
                                </div>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        }
    }
    return (
        <ListPage pageTitle="Список тем обращений" pathToAdd={`/admin/tickets/categories/add`}>
            <div className="m-t-32">
                {buildContent()}
            </div>
        </ListPage>

    );
};

export default withRouter(TicketCategoryList);
